export function buttonClassName({
  variant = "primary",
  size = "md",
  small,
  fullWidth,
  className = "",
}: {
  variant?: string;
  size?: string;
  small?: boolean;
  fullWidth?: boolean;
  className?: string;
} = {}) {
  return `dx-button dx-button--${variant} ${small || size === "sm" ? "dx-button--small" : size === "lg" ? "dx-button--large" : ""} ${fullWidth ? "dx-button--full" : ""} ${className}`;
}
